import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CheckCircle2, Plus } from "lucide-react";
import { toast } from "sonner";
import { errText, formatEUR, formatDate } from "@/lib/api";

const MOD_BADGE = {
  demo: ["Demo", "bg-sky-100 text-sky-900 border-sky-300"],
  active: ["Attivo", "bg-emerald-100 text-emerald-900 border-emerald-300"],
  suspended: ["Demo scaduta", "bg-slate-200 text-slate-800 border-slate-400"],
};

const ExtraModule = ({ api, c, e, mod, onDone }) => {
  const [label, cls] = MOD_BADGE[e.status] || [e.status, ""];
  const confirm = async () => {
    if (!window.confirm(`Confermare l'attivazione del modulo "${mod?.name}"? Da questo momento matura la provvigione.`)) return;
    try { await api.post(`/reseller/customers/${c.id}/modules/${e.id}/confirm-activation`); toast.success("Modulo attivato"); onDone(); } catch (err) { toast.error(errText(err)); }
  };
  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid={`extra-mod-${e.id}`}>
      <span className="text-[11px]">{mod?.name || e.module_id}</span>
      <span className={`text-[10px] px-1.5 py-0.5 rounded-full border ${cls}`} data-testid={`extra-mod-status-${e.id}`}>{label}</span>
      {e.status === "active" && e.activated_at && <span className="text-[10px] text-slate-500">dal {formatDate(e.activated_at)}</span>}
      {e.status !== "active" && c.status === "active" && (
        <Button size="sm" variant="outline" className="h-6 px-2 text-[11px]" onClick={confirm} data-testid={`btn-confirm-module-${e.id}`}><CheckCircle2 size={12} className="mr-1" /> Conferma attivazione</Button>
      )}
    </div>
  );
};

export const CustomerModules = ({ api, c, prod, onDone }) => {
  const [pick, setPick] = useState("");
  const mods = prod?.modules || [];
  const extras = c.extra_modules || [];
  const taken = new Set([...(c.module_ids || []), ...extras.map((e) => e.module_id)]);
  const available = mods.filter((m) => !taken.has(m.id));
  const base = mods.filter((m) => c.module_ids?.includes(m.id) && !extras.some((e) => e.module_id === m.id));
  const add = async () => {
    try { await api.post(`/reseller/customers/${c.id}/modules`, { module_id: pick }); setPick(""); toast.success("Modulo aggiunto in demo"); onDone(); } catch (err) { toast.error(errText(err)); }
  };
  return (
    <div className="space-y-1.5">
      <div className="flex flex-wrap gap-1">
        {base.map((m) => <span key={m.id} className="text-[10px] px-2 py-0.5 rounded-full bg-[#F2F0EB] border border-[#E2DDD5]">{m.name}</span>)}
      </div>
      {extras.map((e) => <ExtraModule key={e.id} api={api} c={c} e={e} mod={mods.find((m) => m.id === e.module_id)} onDone={onDone} />)}
      {["demo", "active"].includes(c.status) && available.length > 0 && (
        <div className="flex items-center gap-1">
          <Select value={pick} onValueChange={setPick}>
            <SelectTrigger className="h-7 text-xs w-44" data-testid={`add-module-select-${c.id}`}><SelectValue placeholder="Aggiungi modulo…" /></SelectTrigger>
            <SelectContent>{available.map((m) => <SelectItem key={m.id} value={m.id}>{m.name} · {formatEUR(m.price)}</SelectItem>)}</SelectContent>
          </Select>
          <Button size="sm" variant="outline" className="h-7 px-2" disabled={!pick} onClick={add} data-testid={`add-module-btn-${c.id}`}><Plus size={12} /></Button>
        </div>
      )}
    </div>
  );
};
